import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a91901c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-bg" }, null, -1))
const _hoisted_3 = { class: "home-wrapper" }
const _hoisted_4 = { class: "home" }
const _hoisted_5 = { class: "m-main-section" }
const _hoisted_6 = { class: "m-main-content" }
const _hoisted_7 = { class: "m-slide" }
const _hoisted_8 = { class: "rank" }

import { ref, reactive, onMounted, watch  } from "vue";
import { useRouter, useRoute } from "vue-router";
import Search from "@/components/paper/search-component.vue";
import { queryExampaperList, queryMultiDetail } from '@/api/index'
import PaperDetail from "../../components/singlePaper/paperDetail.vue";
import RankList from "../../components/singlePaper/rankList.vue";
import UserMember from '@/components/user/userMember.vue'
import IBreadcrumb from "@/components/paper/IBreadcrumb.vue";
import _ from 'lodash';

export default /*#__PURE__*/_defineComponent({
  __name: 'singlePaper',
  setup(__props) {

const router = useRouter();
// url参数解析
const {
  paper_id,
  from = "",
} = router.currentRoute.value.query;

//先从本地取from 参数 如果有的话就不存
if (from) {
  window.sessionStorage.setItem("originFrom", from as string);
}


const breadcrumbData = ref([
  {
    name: '试卷宝首页',
    path: '/paper'
  },
  {
    name: '试卷详情',
    path: `/single-paper?paper_id=${paper_id}`
  }
])

  // 是否滚动到底部
  const isReachBottom = ref(false);
  // 当前滚动高度
  const scrollTop = ref(0);
  //页面总高度
  const scrollHeight = ref(0);
  // 屏幕高度
  const clientHeight = ref(0);
  // 监听window创建的滚动
  // 节流
  const scrollListenerHandler = _.throttle(() => {
    scrollTop.value = document.documentElement.scrollTop;
    scrollHeight.value = document.documentElement.scrollHeight;
    clientHeight.value = document.documentElement.clientHeight;
    // console.log(scrollHeight.value,scrollTop.value + clientHeight.value - 50,'----')
    // 面总高度<=当前滚动高度+屏幕高度就是滚动到底部了
    if (scrollHeight.value <= scrollTop.value + clientHeight.value + 180) {
      isReachBottom.value = true;
    }else{
      isReachBottom.value = false;
    }
  },200)

  onMounted(()=>{
    window.addEventListener("scroll", scrollListenerHandler,true);
  })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Search),
        _createVNode(IBreadcrumb, { data: breadcrumbData.value }, null, 8, ["data"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(PaperDetail, {
              paper_id: _unref(paper_id),
              isReachBottom: isReachBottom.value,
              clientHeight: clientHeight.value
            }, null, 8, ["paper_id", "isReachBottom", "clientHeight"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(UserMember, { pageName: "试卷详情页" }),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(RankList, { rankType: 1 })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})